export const INTAKE_FORM_V2_FEATURE_FLAG = 'onboarding:enable-new-software-only-single-location-intake-form';
